module.exports = __webpack_public_path__ + "img/9788958283591.a7191374.jpg";